import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4a8b9896")

_pushScopeId("data-v-4a8b9896")
const _hoisted_1 = { class: "users" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_users_header = _resolveComponent("users-header")!
  const _component_users_list = _resolveComponent("users-list")!
  const _component_user_form = _resolveComponent("user-form")!
  const _component_s_modal = _resolveComponent("s-modal")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_users_header),
    _createVNode(_component_users_list, {
      users: _ctx.staffUsers.data,
      "total-pages": _ctx.staffUsers.pagination.total_pages,
      "current-page": _ctx.staffUsers.pagination.current_page,
      loading: _ctx.staffUsers.state.is_loading,
      failed: _ctx.staffUsers.state.is_failed,
      onRefresh: _ctx.loadStaffUsersHandler,
      onCreate: _ctx.startCreateUser,
      onUpdate: _ctx.startUpdateUser,
      onDelete: _ctx.deleteUser,
      onLoadmore: _ctx.loadMoreStaffUsers
    }, null, 8, ["users", "total-pages", "current-page", "loading", "failed", "onRefresh", "onCreate", "onUpdate", "onDelete", "onLoadmore"]),
    (_ctx.isUserModalOpened)
      ? (_openBlock(), _createBlock(_component_s_modal, {
          key: 0,
          onClose: _ctx.closeModal
        }, {
          body: _withId(() => [
            _createVNode(_component_user_form, {
              onCreate: _ctx.createUserHandler,
              onUpdate: _ctx.updateUserHandler,
              onClose: _ctx.closeModal,
              loading: _ctx.isUserModalLoading,
              "is-update": _ctx.isUpdateUser,
              "is-create": _ctx.isCreateUser,
              "initial-user": _ctx.updatingUser
            }, null, 8, ["onCreate", "onUpdate", "onClose", "loading", "is-update", "is-create", "initial-user"])
          ]),
          _: 1
        }, 8, ["onClose"]))
      : _createCommentVNode("", true)
  ]))
})